"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeRetrocessionCosts = computeRetrocessionCosts;
const compute_retrocession_price_from_fee_1 = require("./compute-retrocession-price-from-fee");
const find_best_fee_1 = require("./find-best-fee");
const compute_total_quantity_1 = require("../../compute-total-quantity");
const compute_total_weight_1 = require("../../compute-total-weight");
const compute_cost_1 = require("../compute-cost");
const compute_line_price_from_fee_1 = require("../compute-line-price-from-fee");
function computeRetrocessionCosts(params) {
    const fee = (0, find_best_fee_1.findBestFee)(params.feesSchedule, (0, compute_total_quantity_1.computeTotalQuantity)(params.lines), (0, compute_total_weight_1.computeTotalWeight)(params.lines), params.longestDimensionInMillimeters);
    const totalRetrocessionPrice = fee
        ? (0, compute_retrocession_price_from_fee_1.computeRetrocessionPriceFromFee)(fee, (0, compute_total_quantity_1.computeTotalQuantity)(params.lines), (0, compute_total_weight_1.computeTotalWeight)(params.lines))
        : '0';
    const pricedLine = (0, compute_line_price_from_fee_1.computeLinePriceFromFee)(fee, totalRetrocessionPrice, params.lines);
    return {
        costPerLine: pricedLine.map(line => ({
            lineId: line.lineId,
            cost: (0, compute_cost_1.computeCost)(params.vatRate, line.retrocessionPrice)
        })),
        totalCost: (0, compute_cost_1.computeCost)(params.vatRate, totalRetrocessionPrice.toString())
    };
}
